import { useHistory, useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

export const useSearchParams: () => [URLSearchParams, (updatedSearchParams: URLSearchParams) => void] = () => {
    const history = useHistory();
    const location = useLocation();

    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    const setSearchParams = useCallback(
        (updatedSearchParams: URLSearchParams) => {
            history.push({
                search: updatedSearchParams.toString(),
            });
        },
        [history.push],
    );

    return [searchParams, setSearchParams];
};
